import React, { Fragment } from 'react';
import SelectOrgUnit from '@usas/ui-web/components/selectOrgUnit/SelectOrgUnit';
import useOrgUnitSelection from './UseOrgUnitSelection';

const OrgUnitSelection = () => {
  const { 
    NavLinks, 
    RECORDS_ADMIN_ROLE_GROUP_ID } = useOrgUnitSelection();

  return (
    <Fragment>
      <SelectOrgUnit
        pageTitle={'Records Admin'}
        navLink={NavLinks.RECORDS_ADMIN}
        roleGroupId={RECORDS_ADMIN_ROLE_GROUP_ID} />
    </Fragment>
  );
};

export default OrgUnitSelection;